import React, { useState, useEffect } from "react";
import { FaClock, FaTimes } from "react-icons/fa";
import './TempleStatusPopup.css';

const TempleStatusPopup = ({ templeStatus }) => {
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 7000); // Auto-dismiss after 10 seconds

    return () => clearTimeout(timer);
  }, []);

  // Guard clause
  if (!templeStatus?.status || !templeStatus?.upcoming || !showPopup) return null;

  const isOpen = templeStatus.status === "Open";

  return (
    <div className="temple-popup">
      <button
        className="close-popup"
        aria-label="Close popup"
        onClick={() => setShowPopup(false)}
      >
        <FaTimes />
      </button>

      <div className="temple-status">
        <span className={`status-pill ${isOpen ? "open" : "closed"}`}>
          Temple is: {isOpen ? "🟢 Open" : "🔴 Closed"}
        </span>

        <span className="aarti-info">
          <FaClock className="clock-icon" />
          {isOpen ? "Current/Upcoming Aarti: " : "Next Aarti: "}
          <strong>
            {templeStatus.upcoming.time} – {templeStatus.upcoming.label}
          </strong>
        </span>
      </div>
    </div>
  );
};

export const TempleStatusDisplay = ({ templeStatus }) => {
  if (!templeStatus?.status || !templeStatus?.upcoming) return null;

  const isOpen = templeStatus.status === "Open";

  return (
    <div style={{ marginBottom: '10px' }}>
      <p>
        Temple is:{" "}
        <span style={{ color: isOpen ? "green" : "red", fontWeight: "bold" }}>
          {isOpen ? "🟢 Open" : "🔴 Closed"}
        </span>
      </p>
      <p>
        <FaClock style={{ marginRight: "5px" }} />
        {isOpen ? "Current/Upcoming Aarti: " : "Next Aarti: "}
        <strong>{templeStatus.upcoming.time} – {templeStatus.upcoming.label}</strong>
      </p>
    </div>
  );
};



export default TempleStatusPopup;
